import { action, runInAction, observable } from 'mobx';
import {BaseViewStore} from 'core/stores';

class BasePreviewViewStore extends BaseViewStore {

    _actions = null;

    @observable accessor item = null;

    get actions() {
        return this._actions ? (typeof this._actions === 'function' ? this._actions() : this._actions) : {};
    }

    constructor(rootStore, {actions, autoInit = true, id, title, hideColon, onEdit, onCalendar, onPreview, openModal, authorization, routes}) {
        super(rootStore);

        this.id = id;
        this._actions = actions;
        this.routes = routes;
        //this.authorization = compileAuthorization(authorization || rootStore.routerStore.getCurrentRoute().authorization);
        this.authorization = {
            update: authorization ? this.rootStore.permissionStore.hasPermission(authorization) : true
        }
        const { navigationTitle } = this.rootStore.routerStore.transitionData;
        if (navigationTitle || title) {
            this.rootStore.viewStore.setNavigationOptions({
                title: navigationTitle || title,
                hideColon: hideColon,
                onPreview: onPreview,
                onCalendar: onCalendar,
                onEdit: onEdit,
                openModal: openModal
            });
        }

        if (autoInit) {
            this.fetch([
                this.initialize()
            ]);
        }
    }

    @action
    async initialize() {
        await this.getResource(this.id);
    }

    @action
    setItem(item) {
        this.item = item;
    }

    @action.bound
    async getResource(id) {
        const item = await this.actions.get(id);
        runInAction(() => {
            this.setItem(item);
        });
    }

}

export default BasePreviewViewStore;